import React, { useEffect } from 'react';
import { useAwaitControl } from 'react-redux-await-control';
import { cellToDate } from '~/common/utils/table';
import { useDrawer } from '~/hooks/useDrawer';
import { getPortOutAttackHistory } from '~/store/contracts/actions';
import { Table, TableColumns } from '~/ui/components';
import { LinkButton } from './styled';

type PortOutStepLogsDrawerProps = {
  contractId: string;
};

export function PortOutStepLogsDrawer({ contractId }: PortOutStepLogsDrawerProps) {
  const portOutHistoryControl = useAwaitControl(getPortOutAttackHistory);
  const portOutHistoryLoading = portOutHistoryControl.isRunning();
  const history = portOutHistoryControl.result();

  const columns: TableColumns<any> = [
    {
      accessorKey: 'logDate',
      header: () => 'ÚLTIMA ATUALIZ.',
      cell: cellToDate('DD/MM/YYYY [às] HH:mm:ss'),
    },
    {
      accessorKey: 'operationStepNamePortOut',
      header: () => 'PASSO NA ESTEIRA',
    },
    {
      accessorKey: 'reason',
      header: () => 'MOTIVO',
    },
    {
      accessorKey: 'logComment',
      header: () => 'COMENTÁRIO',
    },
  ];

  useEffect(() => {
    if (contractId) {
      portOutHistoryControl.start({ id: contractId });
    }

    return () => {
      portOutHistoryControl.clear();
    };
  }, [contractId]);

  return <Table columns={columns} data={history} loading={portOutHistoryLoading} noPadding />;
}

export type PortOutStepLogsProps = {
  contractId: string;
};

export function PortOutStepLogs({ contractId }: PortOutStepLogsProps) {
  const { openDrawer } = useDrawer();

  const handleClick = () => {
    openDrawer('', <PortOutStepLogsDrawer contractId={contractId} />, {
      title: 'Histórico de ataques',
      width: 814,
      closable: true,
    });
  };

  return <LinkButton onClick={handleClick}>Ver histórico</LinkButton>;
}
